import { useState, useEffect } from 'react';

function useSubmit(url, submitClick, data, fetching, translations) {
  const [submitStatus, setSubmitStatus] = useState('standby');
  // const list = Object.entries(data).map(x => x.join(': ')).join('\r\n');

  useEffect(() => {
    async function fetchToken() {
      const response = await fetch('/session/token');
      const token = await response.text();
      return token;
    }

    async function fetchUrl(token) {
      const orderDetails = { 
        [translations[0].i18n.order.name]: data.namn,
        [translations[0].i18n.order.email]: data.epost,
        [translations[0].i18n.order.phone]: data.telefon,
        [translations[0].i18n.order.address]: data.adress,
        [translations[0].i18n.order.city]: data.ort,
        [translations[0].i18n.order.zip]: data.postnr,
      }
      const objectDetails = {
        [translations[0].i18n.province.label]: data.landskap,
        [translations[0].i18n.squares.label]: data.kvm,
        [translations[0].i18n.floors.label]: data.antal_plan,
        [translations[0].i18n.inclination.label]: data.lutning,
        [translations[0].i18n.color.label]: data.farg,
      }
      const tiles = data.tegelpanna_byte ? {
        [translations[0].i18n.tile.label]: data.tegelpanna_antal,
        [translations[0].i18n.tile.stock]: (data.tegelpanna_lager ? [translations[0].i18n.tile.spares] : [translations[0].i18n.tile.instock]),
      } : {};
      const dropceiling = data.undertak ? {
        [translations[0].i18n.dropceiling.label]: [translations[0].i18n.dropceiling.yes],
      } : {};
      const total = {
        [translations[0].i18n.order.price]: data.total,
        [translations[0].i18n.order.vat]: data.moms,
        [translations[0].i18n.order.total]: data.total_moms,
      };
      const submissionData = {...orderDetails, ...objectDetails, ...tiles, ...dropceiling, ...total};
      const list = Object.entries(submissionData).map(x => x.join(': ')).join('\r\n');

      const key = process.env.REACT_APP_KEY_AUTH;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-key': key,
          Authorization: 'key_auth',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          webform_id: 'order_form',
          body: list,
          email: data.epost,
        }),
      });
      const json = await response.json().then(
        setSubmitStatus(response.status === 200 ? 'success' : 'error'),
      );
      return json;
    }

    if (!fetching && submitClick && submitStatus === 'standby') {
      setSubmitStatus('working');
      fetchToken().then(token => {
        fetchUrl(token);
      });
    }
  }, [url, submitClick, data, fetching, translations, submitStatus]);
  return [submitStatus];
}
export default useSubmit;
